function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { validateError } from '@/services/services';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['tables_views']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
var appApisBackend = axios.create({
  baseURL: process.env.VUE_APP_SVC_APIS_HOST
});
setupInterceptors(appApisBackend);
setupInterceptors(appApisGTW);
var loginObj = function loginObj() {
  return {
    email: window.userInfo.email,
    tokenId: window.userInfo.accessToken,
    localId: window.userInfo.localId
  };
};
var CONTROLLER_NAME = '/tables_views';
var DOMAIN_ASSIGNMENTS = '/access';
export default {
  getMyTables: function getMyTables(data) {
    var _this = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/my_tables', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this.getMyTables(data);
      });
    });
  },
  getMyAccess: function getMyAccess(data) {
    var _this2 = this;
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/my_access', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAccess) Listar accesos de un usuario.';
      return validateError(err, message, function () {
        return _this2.getAccessEmail(data);
      });
    });
  },
  getUserAccess: function getUserAccess(data) {
    var _this3 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/user_access', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this3.getUserAccess(data);
      });
    });
  },
  createTempOwner: function createTempOwner(data) {
    var _this4 = this;
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post(CONTROLLER_NAME + DOMAIN_ASSIGNMENTS + '/create_temp_owner', body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (res) {
      tasks.lockScreen.unlock();
      return res.data;
    }).catch(function (err) {
      var message = '(getAssignments)';
      // const response = validateError(err, message)
      return validateError(err, message, function () {
        _this4.createTempOwner(data);
      });
    });
  },
  getObjectAccess: function getObjectAccess(module) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("/tables_views/access/".concat(module, "/get_object_access"), body).then(function (response) {
      return response.data;
    });
  },
  getObjectAccessBack: function getObjectAccessBack(module) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisBackend.post("/verificar/".concat(module, "/get_object_access"), body).then(function (response) {
      return response.data;
    });
  },
  getObjectAccessWithPending: function getObjectAccessWithPending(module) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("/tables_views/access/".concat(module, "/get_pending_object_access"), body).then(function (response) {
      return response.data;
    });
  },
  postVerifyTableStatus: function postVerifyTableStatus(module) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("/tables_views/access/".concat(module, "/verify_table_status"), body).then(function (response) {
      return response.data;
    });
  }
  /*getMetadataTables(data) {
    const login = loginObj()
    const body = { login, ...data }
    return appApisGTW.post(`${CONTROLLER_NAME}${DOMAIN_ASSIGNMENTS}/get_fields_bq`, body, { headers: { 'Content-Type': 'application/json' }}).then(response => {
      return response.data
    })
  }*/
};